import Clipboard from 'clipboard';

window.Functions = {
  isRtl: $('body').hasClass('is-rtl'),

  dropDown: function(){
    const MENU_CLASS = 'drop-menu';
    const MENU_ITEM_CLASS = `${MENU_CLASS}-item`;
    const ACTIVE_CLASS = 'active';
    const $menu = $(`.${MENU_CLASS}`);

    $menu.on('click', function(e){
      const $el = $(e.target);
      if (
        $el.hasClass(MENU_ITEM_CLASS) ||
        $el.parents().hasClass(MENU_ITEM_CLASS)
      ) return;

      $(this).closest(`.${MENU_CLASS}`).toggleClass(ACTIVE_CLASS);
    });

    $(document).click(function(e){
      $menu.not($(e.target).parents(`.${MENU_CLASS}`)).removeClass(ACTIVE_CLASS);
    });

    $menu.find(`.${MENU_ITEM_CLASS}`).on('click', function() {
      var $this = $(this);
      const $selected = $this.parents(`.${MENU_CLASS}`).find(`.${MENU_ITEM_CLASS}_selected`);
      if ($this.parents(`.${MENU_CLASS}`).is('#menu-currency')) {
        $selected.text($this.attr('data-symbol')).data($this.data())
      } else {
        $selected.text($this.text()).data($this.data())
      }
      $menu.removeClass(ACTIVE_CLASS);
    });
  },

  parseInputValueToArr: function(input){
    return JSON.parse(input.value.replace(/\(/g, '[').replace(/\)/g, ']'));
  },
  getCenter: function(arr){

    var sumLat = 0;
    var sumLng = 0;
    var count = 0;

    arr.forEach(function(item){
      sumLat = sumLat + parseFloat(item[0]);
      sumLng = sumLng + parseFloat(item[1]);
      count++;
    });

    return [sumLat/count, sumLng/count];

  },
  telephoneInput: function() {
    var $telInputs = $('input.phone');
    var userCountry = document.documentElement.dataset.country.toLowerCase();

    var initialCountry = intlTelInputGlobals.getCountryData()
      .map(country => country.iso2)
      .filter(country => country === userCountry)[0]

    $telInputs.each(function() {
      var $telInput = $(this);

      if (intlTelInputGlobals.getInstance(this)) return;

      const initializedIntlTelInput = intlTelInput(this, {
        preferredCountries: [],
        initialCountry: initialCountry || 'ru'
      })

      const errorMsg = $telInput.closest('.iti').find('~ .error-msg');
      const validMsg = $telInput.closest('.iti').find('~ .valid-msg');

      const formatValidNumber = () => {
        if (!$telInput.prop('required') && !$telInput.val()) return;
        const isValidPhone = initializedIntlTelInput.isValidNumber();

        errorMsg.toggleClass('hide', isValidPhone);
        validMsg.toggleClass('hide', !isValidPhone);

        if (($telInput.prop('required') || $telInput.val()) && isValidPhone) {
          $telInput.val(initializedIntlTelInput.getNumber(intlTelInputUtils.numberFormat.NATIONAL));
          window.dispatchEvent(
            new CustomEvent('phone_changed',
              {
                detail: {
                  id: $telInput.attr('id'),
                  value: initializedIntlTelInput.getNumber()
                }
              }
            )
          );
        }
      };

      $telInput.keypress(({ keyCode }) => {
        if (keyCode === 13) formatValidNumber();
      });

      // on keydown: reset
      $telInput.on('input', () => {
        errorMsg.addClass('hide');
        validMsg.addClass('hide');
      });

      $telInput.on('setNumber', (_e, data) => {
        initializedIntlTelInput.setNumber(data);
      });

      $telInput.blur(formatValidNumber);

      //saving in International format
      $telInput.closest('form').on('submit', function(event) {
        if ($telInput.prop('required') || $telInput.val()) {
          if (!initializedIntlTelInput.isValidNumber()) {
            event.preventDefault();
            this.submitting = false;
            errorMsg.removeClass('hide');
            $telInput.focus();
          } else if (this.getAttribute('action')) {
            $telInput.val(initializedIntlTelInput.getNumber());
          }
        }
      });
    });
  },

  isValidIntlPhone (id = 'account_phone') {
    return intlTelInputGlobals
      .getInstance(document.getElementById(id))
      .isValidNumber();
  },

  addCountryName (el) {
    const $el = $(el);
    const country = intlTelInputGlobals.getCountryData().find(
      ({ iso2 }) => iso2 === $el.data('country-iso2')
    );
    if (country) {
      $el.tooltip({
        title: country.name
      });
    } else {
      $el.hide();
    }
  },

  passengerFlags () {
    try {
      let $flags = $('.passenger-country-without-title')

      if (!$flags.length) return

      $flags.each(function(){
        Functions.addCountryName(this);
      });
    } catch (e) {
      Raven.captureException(e)
    }
  },

  dateTimePickerActivate: function() {
    $.datetimepicker.setLocale(document.documentElement.lang);
    $.datetimepicker.setDateFormatter('moment')

    /**
     * Init datetimepicker or datepicker plugins
     * @param {jQuery} $input - jquery element
     * @param {string} type - type of picker: datetime or date
     * @param {object} options - plugin options
     */
    var createDatePicker = function ($input, type, options) {
      if (!$input || !$input.length) { return }

      let defaultOptions

      if (type === 'datetime') {
        defaultOptions = {
          scrollInput: false,
          scrollMonth: false,
          dayOfWeekStart: moment().startOf('week').day(),
          format: 'L'
        };

        if ($input.attr('type') === 'date') {
          const iso8601 = $input.val()
          $input.attr('type', 'text')
          if (iso8601) { $input.val(moment(iso8601).format('L')) }
        }

        $input.attr('type', 'text')
        $input.datetimepicker($.extend({}, defaultOptions, $input.data(), options));
      } else if (type === 'date') {
        defaultOptions = {
          minView: 'months',
          view: 'months',
          language: 'en',
          dateFormat: 'MM yyyy'
        };
        $input.datepicker($.extend({}, defaultOptions, $input.data(), options));
      } else {
        console.error('Datepicker type is not supported: ', type);
      }
    }

    // convert to regular inputs with plugins on desktop
    // leave native inputs on mobile
    if (!Functions.isMobileDevice()) {
      var $date = $('#date'),
          $date_return = $('#date_return'),
          $time = $('#time'),
          $time_return = $('#time_return'),
          $date_end = $('#date_end'),
          $time_end = $('#time_end');

      [$date, $date_return, $time, $time_return, $date_end, $time_end]
        .forEach($item => $item.prev('.input-icon').removeClass('hidden'));

      const twoYearsFromNow = moment().add(2, 'years')

      createDatePicker($date, 'datetime', {
        timepicker: false,
        minDate: 0,
        onShow: function () {
          this.setOptions({
            maxDate: (
              Functions.inputDate($date_return) || Functions.inputDate($date_end) || twoYearsFromNow
            )
          });
        }
      });

      createDatePicker($date_return.add($date_end), 'datetime', {
        timepicker: false,
        onShow: function () {
          this.setOptions({
            minDate: Functions.inputDate($date) || 0,
            maxDate: twoYearsFromNow
          });
        }
      });

      createDatePicker($time.add($time_return).add($time_end), 'datetime', {
        datepicker: false,
        step: 30,
        format: 'HH:mm'
      });

      var $expires_date = $('#expires_date');
      createDatePicker($expires_date, 'datetime', {
        defaultTime: '23:59',
        onShow: function () {
          this.setOptions({
            minDate: 0
          });
        }
      });
    }

    var $begin_date = $('#begin_date');
    var $end_date = $('#end_date');
    var $contract_date = $('#contract_date');
    var $custom_accounting_date = $('#custom_accounting_date');

    createDatePicker($begin_date, 'datetime', {
      defaultTime: '00:00',
      format: 'YYYY-MM-DD HH:mm',
      onShow: function () {
        this.setOptions({
          maxDate: $end_date.val() || false
        });
      }
    });

    createDatePicker($contract_date, 'datetime', {
      format: 'YYYY-MM-DD',
      timepicker: false
    })

    createDatePicker($custom_accounting_date, 'datetime', {
      format: 'YYYY-MM-DD',
      timepicker: false,
      maxDate: $custom_accounting_date.attr('max'),
    })

    createDatePicker($end_date, 'datetime', {
      defaultTime: '23:59',
      format: 'YYYY-MM-DD HH:mm',
      onShow: function () {
        this.setOptions({
          minDate: $begin_date.val() || false
        });
      }
    });

    // init datepicker via data attribute
    var $datePickerInputs = $('[data-gt-datepicker]');
    $datePickerInputs.each(function () {
      createDatePicker($(this), 'date');
    });

    $('.manager-date-filter').each(function () {
      createDatePicker($(this), 'datetime', {
        timepicker: false,
        format: 'YYYY-MM-DD',
      });
    });
  },

  getCurrency: function() {
    return $('#menu-currency .drop-menu-item_selected');
  },

  getCurrencyRate: function() {
    return this.getCurrency().data('currencyRate');
  },

  setSetting: function(settings_name, value, callback) {
    var $spinner = $('#spinner-settings');
    $spinner.removeClass('transparent');
    $.ajax({
      url: '/api?' + settings_name + '=' + value,
      complete: function() {
        if (callback) callback();
        $spinner.addClass('transparent');
      }
    });
  },

  initTransfersMap: function() {
    if (typeof google === "undefined" || !google.maps) return; // 2GIS migration: phase 2
    var map = new google.maps.Map(document.getElementById('transfersMap'), {
      zoom: 4,
      center: {
        lat: 55.755826,
        lng: 37.6173
      },
      streetViewControl: false
    });
    var locations = $('#transfersMap').data('locations');
    var markers = locations.map(function(location) {
      return new google.maps.Marker({ position: location });
    });
    var clusterOptions = {
      minimumClusterSize: 1,
      imagePath: '/img/markerclusterer/m'
    };
    new MarkerClusterer(map, markers, clusterOptions);
  },

  initPricesMap: function() {
    if (typeof google === "undefined" || !google.maps) return; // 2GIS migration: phase 2
    var map = new google.maps.Map(document.getElementById('pricesMap'), {
      zoom: 4,
      center: {
        lat: 55.755826,
        lng: 37.6173
      },
      streetViewControl: false
    });
    var mapData = $('#pricesMap').data('locations')
    var locations = mapData.points
    var thresholds = mapData.thresholds
    var markers = locations.map(function(location) {
      return new google.maps.Marker({
        position: {
          lat: location.lat,
          lng: location.lng
        },
        avgPrice: location.avg_price
      });
    });
    var clusterOptions = {
      minimumClusterSize: 1,
      imagePath: '/img/markerclusterer/m'
    };
    var clusterer = new MarkerClusterer(map, markers, clusterOptions);

    // override default cluster calculator
    clusterer.setCalculator(function (markers, numStyles) {
      var index = 1;
      var count = markers.length;

      var groups = [
        { prices: [] },
        { prices: [] },
        { prices: [] }
      ];

      var clusterPriceGroups = markers.reduce((acc, marker) => {
        var mp = (+marker.avgPrice || 0)
        var groupIndex = 0
        if (mp >= thresholds[0] && mp < thresholds[1]) {
          groupIndex = 1
        } else if (mp >= thresholds[1]) {
          groupIndex = 2
        }
        acc[groupIndex].prices.push(mp);
        return acc;
      }, groups);

      // calculate weighted arithmetic mean
      var clusterPriceWeighted = clusterPriceGroups.reduce((acc, group) => {
        // calculate average
        var average = group.prices.reduce((acc, price) => acc + price, 0);
        average = average / (group.prices.length || 1);

        acc += average * group.prices.length;
        return acc;
      }, 0);
      clusterPriceWeighted = clusterPriceWeighted / count;
      clusterPriceWeighted = clusterPriceWeighted.toFixed(1);

      if (clusterPriceWeighted > thresholds[1]) {
        index = 3; // red
      } else if (clusterPriceWeighted > thresholds[0]) {
        index = 2; // yellow
      }

      index = Math.min(index, numStyles);
      return {
        text: clusterPriceWeighted, index
      };
    });
  },

  holidaysManagement: function($begin, $end, $time) {
    $begin.add($end).on('change', function(event) {
      $time.text(moment($begin.val()).to($end.val(), true));
    });
  },

  setRating: function() {
    var $this = $(this)
    var $container = $this.parent()
    $container.attr('data-rating', $this.data('rate'))

    if ($container.data('url')) {
      $.ajax({
        type: 'POST',
        url: $container.data('url'),
        data: { rating: $this.data('rate') }
      })
    } else {
      $container.find('input[type=hidden]').val($this.data('rate'))
    }
  },

  initPartnerWelcomePage: function() {
    const $el = $('#partner-feedback-slider');

    if (!$el.length) return;

    $el.slick({
      rtl: this.isRtl,
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.partner-welcome-feedback--item-text-block').each(function() {
      const $this = $(this);
      const $button = $this.parent().find('button');

      if ($this.find('p').height() > 250) {
        $button.click(() => {
          const buttonText = $button.text().trim();

          $button.text($button.data('other-text'));
          $button.data('other-text', buttonText);
          $this.toggleClass('expanded');
          if (!$this.hasClass('expanded')) {
            $('html, body').animate({
              scrollTop: $this.parent().offset().top
            });
          }
        })
      } else {
        $button.hide();
      }
    });

    $('.js-partner-modal').click(() => {
      $('#partner-title').val(
        $('.company-name-field').val()
      );
    });
  },

  similarPageSlider: function(selector) {
    const $similarPageSlider = $(selector);

    if ($similarPageSlider.length === 0) return;

    $similarPageSlider.slick({
      arrows: false,
      dots: true,
      dotsClass: 'responsive-slider-dots',
      infinite: false,
      speed: 300,
      rtl: this.isRtl,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  },

  initClipboard: function (el) {
    const clipboard = new Clipboard(el, {
      text: ({ dataset, innerText }) => {
        if (!dataset.clipboardTarget) return dataset.clipboardText || innerText;
      }
    });

    clipboard.on('success', function (e) {
      const getAttr = key => e.trigger.getAttribute(key);
      const clickCopyText = getAttr('title-click-to-copy');
      const copiedText = getAttr('title-copied');

      e.clearSelection();

      $(e.trigger)
        .prop('title', copiedText)
        .tooltip('fixTitle')
        .tooltip('show')
        .prop('title', clickCopyText)
        .tooltip('fixTitle');
    });

    return clipboard;
  },

  convertDate: function(dateObject) {
    const date = Functions.inputDate(dateObject)
    return date && dateObject.val(date.format('YYYY-MM-DD'));
  },

  handleSocialLogin () {
    if (!$('.btn-login').length) return;

    window.addEventListener('message', function(e) {
      const prefix = 'social_login_result_json:';
      if (e.origin === window.location.origin && typeof e.data === 'string' && e.data.startsWith(prefix)) {
        const data = JSON.parse(e.data.replace(prefix, ''));
        if (data.result === 'success') {
          $('#social-login-error').addClass('hidden');
          const { redirect_url, full_name, email, phone } = data;
          if ($('#sign_in-window').length && redirect_url) {
            return location.href = redirect_url;
          }

          $('#name_sign input, #full_name').val(full_name);
          if (email) $('#email').val(email).blur().prop('disabled', true );
          if (phone) $('#phone').trigger('setNumber', phone).keyup().blur().prop('disabled', true );

          $('.btn-login').addClass('hidden');
        } else {
          $('#social-login-error').removeClass('hidden');
        }
      }
    })
  },

  momentFromInput ($input, textFormat) {
    if (!$input.val()) return $input.val()
    if ($input.prop('type') && $input.prop('type') === 'text') {
      return moment($input.val(), textFormat)
    } else if ($input.prop('type') === 'time') {
      return moment($input.val(), 'HH:mm')
    } else if ($input.prop('type') === 'date') {
      return moment($input.val())
    }
  },

  inputDate ($input) {
    const dateObject = Functions.momentFromInput($input, 'L')

    if (dateObject && dateObject.isValid()) return dateObject
  },

  inputTime ($input) {
    return Functions.momentFromInput($input, 'HH:mm')
  },

  inputDateTime($date, $time) {
    const date = Functions.inputDate($date)
    const time = Functions.inputTime($time)

    if (date && time) {
      return date.hours(time.hours()).minutes(time.minutes()).toDate()
    } else if (date) {
      return date.toDate()
    }
  },

  updatePhotoStatus (event) {
    const $this = $(this)
    const $vehicleInfo = $this.closest('.vehicle-info__status')
    const endpoint = $vehicleInfo.data('url')
    const status = $this.val()
    const vehiclePhoto = {
      status,
      reject_reasons: []
    }

    if (event.data.verifyAccess) {
      vehiclePhoto.verified = status === 'approved'
    }

    $vehicleInfo.find('.reason-checkbox:checked').each(function () {
      vehiclePhoto.reject_reasons.push($(this).val())
    })
    $.ajax({
      method: 'PUT',
      url: endpoint,
      data: { vehicle_photo: vehiclePhoto }
    })
      .then(() => {
        if (event.data.isModal) {
          const classRoot = 'vehicle-photos'
          const classStatus = `${classRoot}__status`

          $this
            .parents(`.${classRoot}__image-container`)
            .find(`.${classStatus}`)
            .attr('class', classStatus)
            .addClass(`${classStatus}-${$this.val()}`)
          $this.closest('.modal-vehicle-image-manager').modal('hide')
          $this.attr('disabled', true)
        } else {
          location.reload()
        }
      })
  },

  modalUpdatePhotoStatus () {
    let $this = $(this),
        $reasonsCheckbox = $this.find('.reason-checkbox'),
        $primaryReasonsCheckbox = $reasonsCheckbox.filter('.primary-reason'),
        $btnApproved = $this.find('.btn-photo-approved'),
        $btnRejected = $this.find('.btn-photo-rejected')

    let toggleButtons = function () {
      if ($primaryReasonsCheckbox.filter(':checked').length > 0) {
        $btnApproved.hide()
        $btnRejected.show()
      } else {
        $btnApproved.show()
        $btnRejected.hide()
      }
    }

    toggleButtons()

    $reasonsCheckbox.change(() => {
      toggleButtons()
      $btnApproved.attr('disabled', false)
      $btnRejected.attr('disabled', false)
    })
  },

  isMobileDevice () {
    return $('body').is('.is-ios, .is-android')
  },

  initMobileBanner () {
    const $mobileBanner = $('#mobile-banner');
    const userAgent = navigator.userAgent;
    const isIosWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
    const isAndroidWebView = userAgent.includes(' wv');
    const storageKey = 'bannerHiddenDate';
    const currentTimestamp = moment().valueOf();

    if ($mobileBanner.length) {
      const isHidden = () => {
        try {
          const bannerHiddenDate = parseInt(localStorage.getItem(storageKey));
          if (!bannerHiddenDate) return;
          return moment(bannerHiddenDate).add(2, 'month').valueOf() > currentTimestamp;
        } catch (_) {}
      };

      const handle = action => {
        const hide = action === 'hide';
        $mobileBanner.toggleClass('hidden', hide);
        $('body').css('padding-top', hide ? '' : $mobileBanner.outerHeight());
        if (hide) {
          try {
            localStorage.setItem(storageKey, currentTimestamp);
          } catch (_) {}
        }
      };

      if (!isHidden() && !(isIosWebView || isAndroidWebView)) handle('show');
      $mobileBanner.find('.icon-cancel').click(() => handle('hide'));
    }
  },

  initDownloadVoucherLink () {
    const $select = $('#download-voucher-locale');
    const $link = $('#download-voucher-link');
    if (!$select.length || !$link.length) return;

    $select
      .change(() => {
        $link.attr('href', $link.data('urlBase') + '&locale=' + $select.val());
      })
      .change();
  },

  airlineCardHolder (inputName, regExpression = /[^A-Z]/) {
    const $airlineCardHolder = $(`input[name="transfer[${inputName}]"]`)
    if (!$airlineCardHolder.length) return;

    $airlineCardHolder.on('input', function() {
      this.value = this.value.toUpperCase().replace(regExpression, '')
    })

    $('input[name="transfer[airline_card]"]').on('input', function() {
      $airlineCardHolder.prop({
        required: !!this.value,
        disabled: !this.value,
      })
    })
  },

  initPasswordChecker () {
    const $ = document.querySelector.bind(document);

    const passRegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/;
    const passwordInput = $('#password');
    const passwordConfirmationInput = $('#password_confirmation');

    if (!passwordInput) return;

    const validMessageBlock = $('#password ~ .password-valid');
    const errorMessageBlock = $('#password ~ .password-error');

    const errorConfirmationBlock = $('#password_confirmation ~ .password-error');
    const validConfirmationBlock = $('#password_confirmation ~ .password-valid');

    let isValidPassword = true;
    let isPasswordsMatch = true;
    let passwordConfirmation = '';

    const toggleElement = blocks => {
      blocks.forEach(({ el, show }) => {
        el.style.display = show ? 'block' : 'none';
      });
    };

    const checkPasswordsMatch = value => {
      isPasswordsMatch = passwordInput.value === value && isValidPassword;

      toggleElement([
        {
          el: errorConfirmationBlock,
          show: !!value && isValidPassword && !isPasswordsMatch
        },
        {
          el: validConfirmationBlock,
          show: !!value && isValidPassword && isPasswordsMatch
        }
      ]);
    };

    passwordInput.addEventListener('input', function () {
      isValidPassword = passRegExp.test(this.value);

      toggleElement([
        {
          el: errorMessageBlock,
          show: !!this.value && !isValidPassword
        },
        {
          el: validMessageBlock,
          show: !!this.value && isValidPassword
        }
      ]);

      if (isValidPassword || !passwordInput.value) {
        checkPasswordsMatch(passwordConfirmation);
      }
    });

    passwordConfirmationInput.addEventListener('input', function () {
      passwordConfirmation = this.value;
      if (passwordInput.value) checkPasswordsMatch(this.value);
    });

    passwordInput.form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      if (isValidPassword && isPasswordsMatch || !passwordInput.value && !passwordConfirmationInput.value) {
        this.submit();
      } else {
        (isValidPassword ? passwordConfirmationInput : passwordInput).focus();
        e.preventDefault();
        this.submitting = false;
      }
    });
  },

  convertDatesToLocalTz () {
    const $datesLocal = $('[data-local-date]');
    if (!$datesLocal.length) return;
    const deviceTzOffset = moment().format('Z');
    $datesLocal.each(function () {
      const localDateTz = moment.parseZone(this.dataset.localDate).format('Z');

      if (deviceTzOffset !== localDateTz) {
        this.innerHTML += `
          <span class="text-muted nowrap">
            ${moment(this.dataset.localDate).format()}
          </span>
        `;
      }
    });
  },

  pushAdvcakeData (pageType, leadArgument) {
    window.advcake_data = window.advcake_data || [];
    window.advcake_data.push({
      user: { email: '' },
      pageType,
      ...leadArgument
    });
  },

  setRakutenInitValue () {
    if (document.cookie.includes('rakuten_track_data=') && !window.__rmcp2) {
      window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    }
  }
};
